// src/redux/slices/supportSlice.js

import { createSlice } from "@reduxjs/toolkit";
import { createSupportTicketAction } from "../../actions/support/supportActions";

const supportSlice = createSlice({
  name: "support",
  initialState: {
    loading: false,
    success: false,
    error: null,
    ticketId: null,
  },

  reducers: {
    resetSupportState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.ticketId = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(createSupportTicketAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createSupportTicketAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.ticketId = action.payload?.ticketId;
      })
      .addCase(createSupportTicketAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Error";
      });
  },
});

export const { resetSupportState } = supportSlice.actions;
export default supportSlice.reducer;
